module.exports = __webpack_public_path__ + "img/qr.026d2cdd.svg";